<script setup>
import { onMounted, ref, watch, useAttrs, computed } from 'vue';

const attrs = useAttrs();

const props = defineProps({
    invalid: {
        type: [Boolean],
        default: false,
    },
    width: {
        type: String,
        default: 'w-52'
    }
});

const model = defineModel({
    type: [String, Number],
    default: ''
});

const widthClass = computed(() => {
    return props.width;
});

const input = ref(null);
const isInvalid = ref(props.invalid);
const isDisabled = ref(attrs.disabled);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });

// Watch for changes in the `invalid` prop to update local state
watch(() => props.invalid, (newInvalid) => {
    isInvalid.value = newInvalid;
});

// Validate on blur
const handleBlur = () => {
    validate();
};

const handleFocus = () => {
    if (isInvalid.value) {
        isInvalid.value = false;
    }
};

// Validate input based on your logic (e.g., required fields, email format)
const validate = () => {
    //Make sure required fields have non-space characters
    if (attrs.required != undefined && attrs.required != false && model.value.toString().trim() === '') {
        isInvalid.value = true;
    }
    //Make sure email fields are emails
    else if (attrs.type === 'email' && !/\S+@\S+\.\S+/.test(model.value)) {
        isInvalid.value = true;
    }
    //Otherwise, valid!
    else {
        isInvalid.value = false;
    }
};
</script>

<template>
    <input
        v-model="model"
        ref="input"
        @blur="handleBlur"
        @focus="handleFocus"
    />
</template>
